import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import {
  getBannerList,
  deleteBanner,
  changeStatus,
} from "actions/admin/banner";
import * as Constants from "constants/index";
import DataTable from "react-data-table-component";

import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Input,
  FormGroup,
  CardHeader,
} from "reactstrap";
import Spinner from "views/components/Spinner";
import styled from "styled-components";
import { FaAngleDown, FaAngleUp, FaPencilAlt, FaTrash } from "react-icons/fa";

const Stack = styled.div`
  display: flex;
  flex-direction: ${(props) => props.direction || "row"};
  align-items: ${(props) => props.alignItems || "initial"};
  -webkit-box-align: center;
  & > div:not(:first-child) {
    margin: 0px;
    margin-left: ${(props) =>
      props.direction !== "column" ? (props.gap || 1) * 8 + "px" : "0px"};
  }
`;

const BannerList = ({
  getBannerList,
  deleteBanner,
  history,
  bannerList: { data, count, page },
  sortingParams,
  performDelete,
  loading,
  loadingListData,
}) => {
  const initialSortingParams = {
    limit: 10,
    page: 1,
    orderBy: "updated_at",
    ascending: "desc",
    query: "",
    filters: [],
  };
  const [bannerParams, setBannerParams] = useState(initialSortingParams);
  const [onlyOnce, setOnce] = useState(true);
  const [filterOpen, setFilterOpen] = useState(true);

  let delayTimer;

  const columns = [
    {
      name: "Title",
      minWidth: "150px",
      sortable: true,
      selector: (row) => row.title,
    },
    {
      name: "Heading",
      minWidth: "150px",
      selector: (row) => row.heading,
    },
    {
      name: "Description",
      minWidth: "150px",
      sortable: true,
      selector: (row) => row.description,
      format: (cellContent, row) => (
        <span dangerouslySetInnerHTML={{ __html: cellContent.description }} />
      ),
    },
    {
      name: "Updated At",
      sortable: true,
      selector: (row) => row.updatedAt,
      // headerSortingStyle,
      format: (cellContent, row) => moment(cellContent.updatedAt).format("ll"),
    },
    {
      name: "Actions",
      selector: (row) => row,
      format: (cellContent, row) => (
        <div>
          <Link to={`/home/banner/${cellContent._id}/edit`} title="edit/view">
            <Button
              type="button"
              style={{ marginLeft: 4, color: "white" }}
              size="sm"
              color="success"
            >
              <FaPencilAlt />
            </Button>
          </Link>
          <Button
            type="button"
            size="sm"
            color="danger"
            style={{ marginLeft: 4, color: "white" }}
            onClick={(e) => {
              if (
                window.confirm(
                  `Are you sure you want to delete :\r ${cellContent.title}?`
                )
              ) {
                deleteBanner(cellContent._id, history);
              }
            }}
          >
            <FaTrash />
          </Button>
        </div>
      ),
    },
  ];

  const handleSearch = (e, onSearch, searchDelay) => {
    clearTimeout(delayTimer);
    const text = e.target.value;
    delayTimer = setTimeout(() => {
      onSearch(text);
    }, searchDelay);
  };

  const defaultSorted = [
    {
      dataField: "created_at",
      order: "desc",
    },
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <span className="custom-paginator">
      <span>Records per page: </span>
      <UncontrolledDropdown tag="span">
        <DropdownToggle caret className="dropdown-btn-col-w dropdown-p-28">
          {currSizePerPage}
        </DropdownToggle>
        <DropdownMenu>
          {options.map((option) => (
            <DropdownItem
              tag="li"
              key={option.text}
              onMouseDown={(e) => {
                e.preventDefault();
                onSizePerPageChange(option.page);
              }}
            >
              {option.text}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    </span>
  );

  const options = {
    page: parseInt(bannerParams.page),
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page

    showTotal: true,
    paginationTotalRenderer: customTotal,
    totalSize: count,
    sizePerPageRenderer,
    //sizePerPageOptionRenderer,
    sizePerPageList: [
      {
        text: Constants.DEFAULT_PAGE_SIZE,
        value: Constants.DEFAULT_PAGE_SIZE,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "All",
        value: count,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, searchText, sortField, sortOrder }
  ) => {
    const params = {
      page: type === "search" ? 1 : page || 1,
      limit: sizePerPage,
      orderBy: sortField,
      ascending: sortOrder,
      query: type === "search" ? searchText : bannerParams.query,
    };
    //console.log(params);
    // getLocationList(params);
    setBannerParams((param) => ({ ...param, ...params }));
  };
  useEffect(() => {
    let subscribe = true;
    let updateTimer;
    const asyncParams = async () => {
      try {
        if (subscribe) {
          if (onlyOnce) {
            //resetComponentStore();
            setOnce(false);
          }
          getBannerList(bannerParams);
          // updateTimer = setInterval(function() {
          //   getLocationList(locationParams);
          // }, process.env.REACT_APP_UPDATE_LIST_TIMER);
        }
      } catch (err) {
        // throw err;
      }
    };
    asyncParams();
    return () => {
      subscribe = false;
      clearInterval(updateTimer);
    };
  }, [getBannerList, bannerParams, onlyOnce]);

  useEffect(() => {
    /**
     * Due to asynchronous behavior it is possible that we are dealing with
     * Old value using setState({...params, propery:value });
     * So, to eliminate this situation we are doing function update such as below
     */
    let subscribe = true;
    const asyncParams = async () => {
      if (subscribe) {
        performDelete &&
          setBannerParams((params) => ({
            ...params,
            ...sortingParams,
            page: parseInt(page),
          }));
      }
    };
    asyncParams();
    return () => {
      subscribe = false;
    };
  }, [page, performDelete, sortingParams]);

  const onSearch = (text) => {
    handleTableChange("search", {
      searchText: text,
      sizePerPage: bannerParams.limit,
      sortOrder: bannerParams.ascending,
    });
  };
  const handleSort = (column, sortDirection) => {
    const orderBy = column.field;
    setBannerParams((prevParams) => ({
      ...prevParams,
      orderBy,
      ascending: sortDirection,
    }));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setBannerParams((prevParams) => ({
      ...prevParams,
      limit: newPerPage,
      page,
    }));
  };

  const handlePageChange = async (page) => {
    setBannerParams((prevParams) => ({ ...prevParams, page }));
  };
  return loading ? (
    <Spinner />
  ) : (
    <div className="animated fadeIn" style={{ marginTop: "5%" }}>
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <Stack
                alignItems="center"
                style={{ justifyContent: "space-between" }}
              >
                <div>
                  <h2>Banner List</h2>
                </div>
                <div className="add-button-div">
                  <Link to="/home/banner/create" title="create">
                    <Button color="primary" size="sm">
                      <i className="fa fa-plus"></i> Add New Banner
                    </Button>
                  </Link>
                </div>
              </Stack>
            </CardHeader>
            <CardBody>
              <DataTable
                columns={columns}
                data={data}
                // subHeader={filterOpen}
                progressPending={loadingListData}
                pagination
                paginationServer
                onSort={handleSort}
                sortServer
                paginationTotalRows={count}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

BannerList.propTypes = {
  getBannerList: PropTypes.func.isRequired,
  deleteBanner: PropTypes.func.isRequired,
  changeStatus: PropTypes.func.isRequired,
  bannerList: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  sortingParams: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  bannerList: state.banner.bannerList,
  loading: state.banner.loadingBannerList,
  sortingParams: state.banner.sortingParams,
  performDelete: state.banner.performDelete,
  loadingListData: state.banner.loadingListData,
});

export default connect(mapStateToProps, {
  getBannerList,
  deleteBanner,
})(BannerList);
